import { registerQuery } from 'data-fetching-client';
import { getProductInfo } from '../api/product-info.api';
export const fetchProductInfoQuery = registerQuery({
  fetcher: getProductInfo,
  fieldName: 'productInfo'
});